export const clickedOnElement = (event: MouseEvent, className: string): boolean => {
  const toastElements = document.getElementsByClassName(className);

  return toastElements && toastElements[0] && toastElements[0].contains(event.target as HTMLDivElement);
};
